import { Box, useRadio } from '@chakra-ui/react';

export const RadioCard = props => {
	const { getInputProps, getCheckboxProps } = useRadio(props);
	const { w } = props;

	const input = getInputProps();
	const checkbox = getCheckboxProps();
	const box = { as: 'label', d: 'block', w };

	return (
		<Box {...box}>
			<input {...input} />
			<Box
				{...checkbox}
				cursor="pointer"
				borderWidth="1px"
				borderRadius="md"
				boxShadow="md"
				_checked={{
					bg: 'teal.600',
					color: 'white',
					borderColor: 'teal.600',
				}}
				_focus={{
					boxShadow: 'outline',
				}}
				px={5}
				py={3}
			>
				{props.children}
			</Box>
		</Box>
	);
};
